export default __webpack_public_path__ + "static/offwhite_transparent-9275e484c781caf9cfd34335273cc59d.png";